export class PreWriteCheckError extends Error {
  readonly originalError: Error

  constructor(originalError: unknown) {
    const error = originalError instanceof Error ? originalError : new Error('Unknown pre-write error')
    super(error.message)
    this.name = 'PreWriteCheckError'
    this.originalError = error
  }
}
